/**
 * a globalRoute must start with /
 */
export const globalRoutes: Array<string> = [
	'/',
	'/tv',
	'/refresh',
	'/privacy-policy',
	'/terms',
	'/pseudonym-ID',
	'/shared',
];
